// extracted by mini-css-extract-plugin
module.exports = {"negative":"Balance_negative__2Gyxe","positive":"Balance_positive__1d7fk","background":"Balance_background__12VsI"};